/* eslint-disable no-console */

import axios from 'axios'

const serverState = {
  hasBeenInitialised: false,
  serverUrl: '',
  headers: {},
}

let onError = err => {
  if (err && err.msg) {
    const {
      msg = err && err.response && err.response.statusText,
      code = err.code || err.status || err.response && err.response.status,
      ...extraInfos
    } = err || {}

    const fullMsg = `${code} ${msg}`
    const content = JSON.stringify(extraInfos, null, 2)
      .replace(/^ {2}(\s*)"([^"]+)"/gm, '$1$2')
      .replace(/(^{|}$)/g, '')

    console.error(fullMsg, content)
  } else {
    console.error(err)
  }
}

function init(serverBaseUrl, onErrorCallback = () => { }, headers = {}) {
  if (serverBaseUrl) serverState.serverUrl = serverBaseUrl.replace(/(^\/|\/$)/g, '')
  if (onErrorCallback) onError = onErrorCallback
  serverState.headers = headers
  serverState.hasBeenInitialised = true
}

function setHeaders(newHeaders, mergeWithPrevious = false) {
  if (mergeWithPrevious) Object.assign(serverState.headers, newHeaders)
  else serverState.headers = newHeaders
}

async function apiCall(route, ...params) {
  if (serverState.hasBeenInitialised) {
    await onApiCallFnCache(route, ...params)
    try {
      const fullUrl = [serverState.serverUrl, route.replace(/^\//, '')].join('/')
      const { data, status } = await axios.post(
        fullUrl,
        { params },
        {
          headers: serverState.headers,
          validateStatus: function (status) {
            return status < 500 // Resolve only if the status code is less than 500
          }
        }
      )
      if (status === 200) return data === '' ? undefined : data // conversion problem between express <=> axios
      else onError(data)
    } catch (err) {
      onError(err.response && err.response.data || err.data || err)
    }
  } else throw new Error('Api service has not been initialized. Please use apiService.init() before using apiService')
}

let onApiCallFnCache = () => true

async function beforeApiCall(fn) {
  onApiCallFnCache = fn
}

export { init, apiCall, setHeaders, onError, beforeApiCall }
